import ExcelImg from '@/assets/icons/files-icons/File.svg';
import PDFImg from '@/assets/icons/files-icons/pdfIcon.svg'
import OtherImg from '@/assets/icons/files-icons/File.svg';
import WordImg from '@/assets/icons/files-icons/File.svg';
import CommonMimeTypes from '@/reference/common-mime-types'

export default {
  [CommonMimeTypes.csv]: ExcelImg,
  [CommonMimeTypes.xls]: ExcelImg,
  [CommonMimeTypes.xlsx]: ExcelImg,
  [CommonMimeTypes.doc]: WordImg,
  [CommonMimeTypes.docx]: WordImg,
  [CommonMimeTypes.pdf]: PDFImg,
  default: OtherImg
};
